<template>
  <div
    class="absolute flex items-center justify-center bottom-0 z-999 left-50"
    style="transform-origin: center center; transform: translate(-50%, -50%)"
    @click="navigate"
  >
    <div
      class="relative flex items-center justify-center ph4 pv2"
      style="border-radius: 110px;"
    >
      <div
        class="absolute w-100 h-100"
        :class="{
          'bg-purple': brand === 'lh',
          'bg-dark-gray': brand === 'lq'
        }"
        style="border-radius: 110px; opacity: 0.8; z-index: -1;"
      />
      <div
        class="border-outline absolute ba bw2 b--white"
        style="border-radius: 110px; opacity: 0.8; z-index: -1;"
      />
      <h4 class="b white mr3 ttu tracked">
        EXPLORE
      </h4>
      <div
        class="flex flex-column justify-center items-center"
        ref="arrow"
      >
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.00523589 8.07043C0.0429042 8.49555 0.358591 8.88251 0.767244 9.00449C1.17589 9.12647 1.65175 8.97579 1.91594 8.64077L5.38537 4.48069C5.38537 6.74167 5.38537 9.02107 5.38537 11.2744C5.41161 11.8366 5.9466 12.3242 6.50832 12.2978C7.07004 12.2715 7.55714 11.7359 7.5307 11.1737V4.48069L10.9834 8.64077C11.3432 9.07553 12.0658 9.14346 12.5002 8.78335C12.9346 8.42324 13.0024 7.70002 12.6426 7.26526L7.2793 0.823848C6.87843 0.334434 6.02087 0.334434 5.61999 0.823848L0.256662 7.26526C0.0692006 7.48504 -0.0238256 7.78292 0.00523589 8.07043Z"
            fill="#F8F9FA"
          />
        </svg>
        <svg
          width="3"
          height="5"
          viewBox="0 0 3 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.36435 3.23309C0.390589 3.79529 0.925583 4.2829 1.4873 4.25655C2.04902 4.2302 2.53612 3.69463 2.50968 3.13244L2.50968 2.05887C2.51767 1.49169 2.00376 0.970015 1.437 0.970015C0.870239 0.970016 0.356339 1.49169 0.36435 2.05887C0.364297 2.44537 0.36435 2.85479 0.36435 3.23309Z"
            fill="#F8F9FA"
          />
        </svg>
        <svg
          width="3"
          height="5"
          viewBox="0 0 3 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.36435 3.23309C0.390589 3.79529 0.925583 4.2829 1.4873 4.25655C2.04902 4.2302 2.53612 3.69463 2.50968 3.13244L2.50968 2.05887C2.51767 1.49169 2.00376 0.970015 1.437 0.970015C0.870239 0.970016 0.356339 1.49169 0.36435 2.05887C0.364297 2.44537 0.36435 2.85479 0.36435 3.23309Z"
            fill="#F8F9FA"
          />
        </svg>
        <svg
          width="3"
          height="5"
          viewBox="0 0 3 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.36435 3.23309C0.390589 3.79529 0.925583 4.2829 1.4873 4.25655C2.04902 4.2302 2.53612 3.69463 2.50968 3.13244L2.50968 2.05887C2.51767 1.49169 2.00376 0.970015 1.437 0.970015C0.870239 0.970016 0.356339 1.49169 0.36435 2.05887C0.364297 2.44537 0.36435 2.85479 0.36435 3.23309Z"
            fill="#F8F9FA"
          />
        </svg>
        <svg
          width="3"
          height="5"
          viewBox="0 0 3 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.36435 3.23309C0.390589 3.79529 0.925583 4.2829 1.4873 4.25655C2.04902 4.2302 2.53612 3.69463 2.50968 3.13244L2.50968 2.05887C2.51767 1.49169 2.00376 0.970015 1.437 0.970015C0.870239 0.970016 0.356339 1.49169 0.36435 2.05887C0.364297 2.44537 0.36435 2.85479 0.36435 3.23309Z"
            fill="#F8F9FA"
          />
        </svg>
        <svg
          width="3"
          height="5"
          viewBox="0 0 3 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.36435 3.23309C0.390589 3.79529 0.925583 4.2829 1.4873 4.25655C2.04902 4.2302 2.53612 3.69463 2.50968 3.13244L2.50968 2.05887C2.51767 1.49169 2.00376 0.970015 1.437 0.970015C0.870239 0.970016 0.356339 1.49169 0.36435 2.05887C0.364297 2.44537 0.36435 2.85479 0.36435 3.23309Z"
            fill="#F8F9FA"
          />
        </svg>
      </div>
      <svg
        class="ml2"
        width="37"
        height="48"
        viewBox="0 0 37 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          ref="hand"
          d="M14.0578 0.971924C12.8967 0.971924 11.8905 1.42096 11.2397 2.14515C10.5928 2.86503 10.29 3.80552 10.3003 4.72625C10.3001 11.8775 10.3141 19.1321 10.3171 25.3249C10.2684 25.2027 10.2145 25.0959 10.1661 24.9729C9.5366 23.3723 8.96832 21.7458 7.85123 20.5984C7.8403 20.587 7.82911 20.5758 7.81769 20.5649C6.14297 18.9557 3.85755 18.8782 2.19823 19.9783C2.17522 19.9941 2.15283 20.011 2.13113 20.0285C1.10973 20.816 0.671875 21.9674 0.638199 22.9951C0.61966 23.5609 0.707102 24.0949 0.864633 24.5809C1.00729 24.9945 1.20001 25.3665 1.3595 25.6768C4.88083 32.5657 7.68068 38.7045 11.0216 43.9122C11.3236 44.3883 12.0329 44.5458 12.5083 44.2422C12.9837 43.9388 13.1387 43.2295 12.8333 42.7556C9.59867 37.7137 6.79026 31.5799 3.22147 24.6041C3.08281 24.3726 3.02236 24.2195 2.95241 24.0645C2.84562 23.7569 2.77445 23.3942 2.78534 23.0622C2.8023 22.5442 2.97264 22.1285 3.43954 21.7548C4.40317 21.1324 5.24531 21.0888 6.30798 22.09C6.32092 22.1022 6.32852 22.1111 6.34153 22.1236C6.92785 22.7467 7.54894 24.1816 8.16995 25.7606C8.79932 27.3607 9.44355 29.0974 10.5687 30.4033C10.8496 30.7371 11.3464 30.8701 11.7568 30.7213C12.1671 30.5725 12.4629 30.1522 12.4642 29.7161C12.4655 21.1021 12.448 12.3232 12.4474 4.70945C12.4407 4.26461 12.5871 3.86041 12.8333 3.5865C13.0794 3.31259 13.418 3.11722 14.0578 3.11722H14.5946C15.3851 3.11722 16.2049 4.02309 16.2049 4.72622C16.205 9.91745 16.2049 15.2232 16.2049 20.3637C16.2269 20.9254 16.7583 21.4165 17.3204 21.3946C17.8826 21.3726 18.3741 20.8416 18.3521 20.2799V20.1793C18.3498 20.153 18.4343 19.8765 18.7882 19.6095C19.1421 19.3425 19.6667 19.1776 19.8953 19.1905C19.9009 19.1961 19.9065 19.2017 19.9121 19.2072C20.6092 19.2417 20.9763 19.4375 21.2037 19.6765C21.4311 19.9155 21.5728 20.2609 21.5728 20.8162V21.8889C21.5734 22.3722 21.9421 22.8305 22.4144 22.9349C22.8868 23.0393 23.4146 22.7794 23.6193 22.3414C23.8742 21.7978 24.0848 21.4218 24.3406 21.2017C24.5963 20.9817 24.9406 20.8025 25.8503 20.8162C26.0539 20.8184 26.7571 20.8667 27.2426 21.1347C27.728 21.4027 28.0901 21.6896 28.0142 22.8946C27.9785 23.3449 28.261 23.8025 28.6797 23.9728C29.0984 24.1431 29.6205 24.0125 29.9097 23.6655C29.9328 23.6457 29.9848 23.5879 30.0439 23.5482C30.1621 23.469 30.3317 23.372 30.5304 23.28C30.9277 23.096 31.426 22.9615 31.7717 22.9616C32.5285 22.9617 33.2208 23.2736 33.7175 23.7326C34.2142 24.1915 34.4556 24.7902 34.4556 25.1069V32.4982C34.2709 34.1956 33.6496 37.4439 32.6272 40.1913C32.116 41.565 31.5028 42.8262 30.8491 43.6776C30.1954 44.5289 29.582 44.9156 29.0207 44.9514H14.5946C14.0274 44.9433 13.5057 45.4572 13.5057 46.0239C13.5057 46.5907 14.0274 47.1046 14.5946 47.0967H29.0878C29.1103 47.0913 29.1327 47.0859 29.1549 47.08C30.5662 46.99 31.6974 46.0918 32.5601 44.9683C33.4227 43.8448 34.0831 42.4424 34.6401 40.9457C35.7541 37.9524 36.3954 34.6377 36.6027 32.7331C36.6031 30.2021 36.6027 27.6465 36.6027 25.1071C36.6027 23.9781 36.0304 22.9458 35.1769 22.1572C34.3234 21.3686 33.1288 20.8165 31.7717 20.8164C31.0585 20.8163 30.4249 21.0047 29.8762 21.2354C29.5352 20.3149 28.9415 19.6214 28.2826 19.2577C27.2475 18.6863 26.233 18.6744 25.8838 18.6711C24.8683 18.6557 24.081 18.92 23.4347 19.308C23.2774 18.8974 23.0729 18.5099 22.7638 18.185C22.1027 17.4902 21.1256 17.1197 20.0295 17.062C20.0238 17.0617 20.0185 17.0623 20.0128 17.062C19.4169 17.0314 18.866 17.1934 18.3521 17.4308V4.72635C18.3521 2.71902 16.6983 0.971989 14.5946 0.971989L14.0578 0.971924ZM31.6543 29.9172C31.1267 29.9751 30.6867 30.4765 30.6981 31.0067V33.152C30.7017 34.5657 30.0305 36.7788 29.7084 37.56C29.4515 38.0843 29.7214 38.7986 30.261 39.0225C30.8005 39.2463 31.4974 38.9331 31.6878 38.3813C32.1149 37.3454 32.8462 35.1532 32.8452 33.152C32.8452 32.4381 32.8452 31.7215 32.8452 31.0067C32.8584 30.3981 32.2597 29.8506 31.6543 29.9172ZM29.0207 40.1076C28.6372 40.1323 28.2762 40.3793 28.1148 40.7277C27.9674 41.0404 27.7622 41.372 27.5613 41.834C27.3373 42.3517 27.605 43.0264 28.1232 43.2502C28.6414 43.474 29.3167 43.2062 29.5407 42.6887C29.6703 42.3907 29.8536 42.0886 30.0607 41.6495C30.3908 40.9761 29.7692 40.0547 29.0207 40.1076Z"
          fill="#F8F9FA"
        />
      </svg>
      <svg
        style="display: none;"
        width="36"
        height="48"
        viewBox="0 0 36 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          ref="handpress"
          d="M11.5918 0.941162C10.5335 1.26041 9.66708 1.22326 9.01629 1.94744C8.36937 2.66733 7.97794 4.38634 8.07163 5.03907C9.30255 13.6152 9.54241 19.1322 9.54541 25.325C9.49674 25.2028 9.44277 25.0959 9.39443 24.973C8.76492 23.3724 8.51617 20.8074 7.39909 19.66C7.38815 19.6486 7.37696 19.6374 7.36554 19.6265C5.69082 18.0173 3.40541 17.9398 1.74608 19.0398C1.72307 19.0557 1.70068 19.0725 1.67898 19.0901C0.657581 19.8776 0.219727 21.0289 0.186051 22.0567C0.167512 22.6224 0.254953 23.1565 0.412484 23.6425C0.555138 24.0561 0.78313 24.8305 0.942627 25.1408C4.46396 32.0297 6.909 38.7046 10.2499 43.9123C10.5519 44.3884 11.2612 44.5459 11.7366 44.2423C12.212 43.9389 12.367 43.2296 12.0616 42.7557C8.82698 37.7138 6.33811 30.6414 2.76932 23.6657C2.63066 23.4342 2.57021 23.2811 2.50026 23.126C2.39347 22.8185 2.3223 22.4558 2.33319 22.1237C2.35015 21.6058 2.52049 21.1901 2.98739 20.8164C3.95102 20.194 4.79317 20.1504 5.85583 21.1516C5.86878 21.1638 5.87637 21.1727 5.88938 21.1852C6.4757 21.8083 6.77727 24.1817 7.39828 25.7607C8.02765 27.3608 8.67187 29.0975 9.79702 30.4034C10.0779 30.7372 10.5747 30.8702 10.9851 30.7214C11.3955 30.5726 11.6913 30.1523 11.6925 29.7161C11.6938 21.1022 11.3064 12.4533 9.98146 4.67869C9.9747 4.23385 10.1211 3.82965 10.3673 3.55574C10.6134 3.28183 10.952 3.08646 11.5918 3.08646H12.1286C12.9191 3.08646 13.739 3.99233 13.739 4.69546C15.4333 12.8254 15.4333 15.2233 15.4333 20.3638C15.4552 20.9255 15.9867 21.4166 16.5488 21.3946C17.1109 21.3727 17.6024 20.8417 17.5804 20.28V20.1794C17.5782 20.1531 17.6626 19.8765 18.0166 19.6096C18.3705 19.3426 18.895 19.1776 19.1237 19.1906C19.1292 19.1962 19.1348 19.2018 19.1405 19.2073C19.8376 19.2418 20.2047 19.4376 20.4321 19.6766C20.6595 19.9156 20.8011 20.261 20.8011 20.8163V21.889C20.8018 22.3723 21.1705 22.8306 21.6428 22.935C22.1151 23.0394 22.6429 22.7795 22.8476 22.3415C23.1026 21.7979 23.3132 21.4219 23.5689 21.2018C23.8247 20.9818 24.169 20.8026 25.0786 20.8163C25.2823 20.8185 25.9855 20.8668 26.4709 21.1348C26.9563 21.4027 27.3184 21.6897 27.2425 22.8947C27.2069 23.345 27.4893 23.8026 27.9081 23.9729C28.3268 24.1432 28.8488 24.0126 29.1381 23.6656C29.1612 23.6458 29.2132 23.588 29.2723 23.5483C29.3905 23.4691 29.56 23.3721 29.7587 23.2801C30.1561 23.0961 30.6543 22.9616 31 22.9617C31.7568 22.9618 32.4491 23.2737 32.9458 23.7326C33.4426 24.1916 33.6839 24.7902 33.6839 25.107V32.4983C33.4992 34.1957 32.8779 37.444 31.8555 40.1914C31.3443 41.5651 30.7311 42.8263 30.0774 43.6777C29.4237 44.529 28.8103 44.9157 28.249 44.9515H13.8229C13.2557 44.9434 12.734 45.4573 12.734 46.024C12.734 46.5908 13.2557 47.1047 13.8229 47.0967H28.3161C28.3386 47.0914 28.361 47.086 28.3832 47.0801C29.7945 46.9901 30.9257 46.0919 31.7884 44.9684C32.6511 43.8449 33.3115 42.4425 33.8684 40.9458C34.9824 37.9525 35.6237 34.6378 35.831 32.7332C35.8314 30.2021 35.831 27.6465 35.831 25.1072C35.831 23.9782 35.2587 22.9459 34.4052 22.1573C33.5517 21.3687 32.3572 20.8166 31 20.8165C30.2868 20.8164 29.6533 21.0048 29.1045 21.2355C28.7635 20.315 28.1698 19.6215 27.5109 19.2578C26.4758 18.6864 25.4613 18.6745 25.1122 18.6711C24.0966 18.6558 23.3093 18.9201 22.6631 19.308C22.5057 18.8975 22.3013 18.51 21.9921 18.1851C21.3311 17.4903 20.354 17.1197 19.2579 17.0621C19.2521 17.0618 19.2468 17.0624 19.2411 17.0621C18.6453 17.0315 18.0943 17.1935 17.5804 17.4309C17.5804 17.4309 17.1462 12.5391 16.8599 10.3063C16.5736 8.07345 15.7148 4.29479 15.7148 4.29479C15.4333 2.40546 14.2323 0.941228 12.1286 0.941228L11.5918 0.941162ZM30.8826 29.9173C30.3551 29.9752 29.915 30.4766 29.9265 31.0068V33.1521C29.93 34.5658 29.2589 36.7789 28.9368 37.5601C28.6799 38.0844 28.9497 38.7987 29.4893 39.0226C30.0289 39.2464 30.7258 38.9332 30.9162 38.3814C31.3432 37.3455 32.0745 35.1533 32.0736 33.1521C32.0736 32.4382 32.0736 31.7216 32.0736 31.0068C32.0867 30.3982 31.4881 29.8507 30.8826 29.9173ZM28.249 40.1077C27.8656 40.1324 27.5045 40.3794 27.3432 40.7278C27.1958 41.0405 26.9905 41.3721 26.7896 41.8341C26.5657 42.3518 26.8334 43.0265 27.3516 43.2503C27.8698 43.4741 28.5451 43.2063 28.769 42.6888C28.8986 42.3908 29.082 42.0887 29.289 41.6496C29.6191 40.9762 28.9976 40.0548 28.249 40.1077Z"
          fill="#F8F9FA"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'
import MorphSVGPlugin from 'gsap/MorphSVGPlugin'
gsap.registerPlugin(MorphSVGPlugin)

export default {
  name: 'SlideUpButon',
  props: {
    brand: {
      type: String,
      default: 'lh'
    }
  },
  methods: {
    navigate () {
      this.$store.commit('setSidebarNav', 0)
      this.$store.commit('setActiveTab', 0)
      this.$router.push(this.$route.path + '/floorplans')
    },
    animateButton () {
      const arrowPaths = this.$refs.arrow.querySelectorAll('svg')
      const tl = gsap.timeline({ repeat: -1 })
      tl.to(this.$refs.hand,
        {
          morphSVG: this.$refs.handpress,
          duration: 0.3
        }
      ).to(this.$refs.hand,
        {
          morphSVG: this.$refs.hand,
          duration: 0.3
        }
      ).fromTo(arrowPaths,
        {
          y: 20 + 'px',
          opacity: 0
        },
        {
          y: 0 + 'px',
          opacity: 1,
          duration: 0.5,
          stagger: 0.05
        },
        '-=1.3'
      ).fromTo(arrowPaths,
        {
          y: 0 + 'px',
          opacity: 1
        },
        {
          opacity: 0,
          y: -20 + 'px',
          duration: 0.5,
          delay: -0.1,
          stagger: 0.05
        }
      )
    }
  }
}
</script>

<style lang="scss">
  .border-outline {
    width: calc(100% + 20px);
    height: calc(100% + 20px);
  }
</style>
